import { sendDelete, sendGet, sendPost, sendPut } from "api/restUtil";
import {useEffect, useMemo, useState} from 'react';
import SearchList from 'components/SearchList';
import ReactDataTableDisplay from 'components/DataTable/ReactDataTableDisplay';
import { getIsoDateToDisplay, getTodayStr } from "js/common";

// 상품 주문 배치 결과
function OrderSchedResult() {

	//데이터 목록
	const [ dataList, setDataList ] = useState([]);
	//초기 검색 조건 데이터
	const [ initialCondition, setInitialCondition] = useState({});
	//검색 데이터
	const [ condition, setCondition] = useState({});
	// 페이징 정보
    const [pagingInfo, setPagingInfo] = useState({});

	//검색 조건
	const conditionList = [
		{
			title : "조회일시",
			col : "searchDt",
			type : "datePicker",
		},
		{
			title: "성공여부",
			col: "succYn",
			type: "select",
			option: [
				{label: "전체", value: ""},
				{label: "성공", value: "Y"},
				{label: "실패", value: "N"},
			]

		},
	];
	
	// 재실행
	const retrySchedule = async (d) => {
		if(!window.confirm("재실행 하시겠습니까")) return;
		const result = await sendPost("/api/scheduler-retry/product-order", d);
		if(result.respCode === "SUCCESS") {
			alert("성공했습니다.");
			searchList(condition);
			return;
		}
	}
	
	
	//데이터 테이블 컬럼
	const columns = useMemo(() =>[
		{ header : "스케쥴ID", col : "schedId", notView: true},
		{ header : "조건", col : "cond", notView: true},
		{ header : "조회시작일시", col : "condStartDt", notView: true},
		{ header : "조회종료일시", col : "condEndDt", notView: true },
		{ header : "배치시작일시", col : "startDtStr", cellWidth: "100"},
		{ header : "배치종료일시", col : "endDtStr", cellWidth : "100" },
		{ header : "조회시작일시", col : "condStartDtDisp", cellWidth: "100"},
		{ header : "조회종료일시", col : "condEndDtDisp", cellWidth : "100" },
		{ header : "결과", col : "finalSuccYn", cellWidth : "100" },
		{ header : "재실행", col : "showRetry", type: "modButton", label: "재실행", onClick: retrySchedule, cellWidth : "100" },
	], []);

	useEffect(() =>{
		const initData = async () => {
			
			//초기 검색 조건
			const today = getTodayStr();
			const newCond = {searchDt: today, succYn: "N"};
			setInitialCondition(newCond);
			searchList(newCond);
		};

		initData();

	}, []);


	//목록 조회
	const searchList = async (cond = {}) => {

		
		let result = await sendGet("/api/scheduler-hist/product-order", cond);
		if(result.respCode === "SUCCESS"){

			setCondition(cond);
			result.data.list.forEach(d => {
				d.startDtStr = getIsoDateToDisplay(d.startDt);
				d.endDtStr = getIsoDateToDisplay(d.endDt);
				const condObj = JSON.parse(d.cond);
				d.condStartDt = condObj.lastChangedFrom;
				d.condEndDt = condObj.lastChangedTo;
				d.condStartDtDisp = getIsoDateToDisplay(condObj.lastChangedFrom);
				d.condEndDtDisp = getIsoDateToDisplay(condObj.lastChangedTo);
				if(d.finalSuccYn === "N") {
					d.showRetry = d.cond;
				}
			});

			setDataList(result.data.list);
			setPagingInfo({...result.data, list: [], searchFnc: searchList, searchCond: cond });
		}
	}

	return (
		<div className="ant-tabs-tabpane">
			<SearchList conditionList={conditionList} onSearch={searchList} initialData={initialCondition} />

			<div className="table-buttons mg-t-10 mg-b-10">
			</div>

			<ReactDataTableDisplay
				columns={columns}
				customDatas={dataList}
				hideCheckBox={true}
				percentageWidth={true}
				isPageNation={false}
				pagingInfo={pagingInfo}
				// rowClick={"checkbox"}
			/>


		</div>
	);
}

export default OrderSchedResult;